

import React, { useState } from "react";

function FormatTime(props)
{

    var minute = props.minute

    var h =  parseInt( minute / 60);
    var m =  parseInt(minute % 60 );

    if((h+"").length == 1) h = "0" + h;
    if((m+"").length == 1) m = "0" + m;



    var fTime =  h + ":" + m;


    return <React.Fragment>
        {fTime}
    </React.Fragment>
}

export default FormatTime;